import { atom } from 'jotai';
import { DirtyState } from 'types';

export const isDirtyAtom = atom<DirtyState>({
  'Account Details': true, // Set to default true to always mutate - send POST request - on submitting Accounts Details
  Properties: false,
  'Brand Signifiers': false,
  'Whitelisted Domains': false,
  'Auction Insights File': true, // Set to default true to always mutate - send POST request - on Auction Insights page on clicking Initiate
});
